import React, { Component } from "react";

import Places from "../data/places";
import styles from "./timeline.module.css";

const Circle = props => (
  <div className={styles.register}>
    <div className={styles.registerblue}>
      <div className={styles.circle} />
    </div>
  </div>
);

const TimelineEvent = props => (
  <li
    className={props.className}
    onMouseEnter={() => {
      props.hoverHandler(props.latitude, props.longitude);
      props.handleActiveIndex(props.index);
    }}
  >
    <Circle />
    <h4>{props.place}</h4>
    <span>{props.yearRange}</span>
  </li>
);

class Timeline extends Component {
  state = {
    activeIndex: Places.length - 1
  };

  handleActiveIndex = index => this.setState({ activeIndex: index });

  render() {
    return (
      <div className={styles.timeline}>
        <ul>
          {Places.map((place, index) => {
            const className =
              this.state.activeIndex === index ? styles.active : "";

            return (
              <TimelineEvent
                key={index}
                index={index}
                place={place.city}
                yearRange={place.yearRange}
                hoverHandler={this.props.hoverHandler}
                latitude={place.latitude}
                longitude={place.longitude}
                className={className}
                handleActiveIndex={this.handleActiveIndex}
              />
            );
          })}
        </ul>
      </div>
    );
  }
}

export default Timeline;



// WEBPACK FOOTER //
// ./src/components/timeline.js